<template>
  <div class="TimeEvent">
    <div class="time" :style="inputColor">
      <div class="year">{{time.year}}{{time.date}}</div>
      <div class="main">{{event.main}}</div>
      <div class="desc">{{event.sub}}</div>
    </div>
  </div>
</template>

<script>
 import MyImage from '@/components/Image.vue';
 import Arrow from '@/assets/image/frontpage/arrow-bottom.png';
 export default {
   name: 'TimeEvent',
   props: ['event', 'time', 'color'],
   computed: {
     imgWidth () {
       return this.$store.state.mediaPhone? '2vw': '1.35vw'
     },
     arrow () {
       return Arrow
     },
     inputColor () {
       return {
         'background': this.color
       }
     }
   },
   components: {
     my_image: MyImage
   }
 }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .TimeEvent{
   color: white;
   display: flex;
   flex-direction: column;
   align-items: center;
 }
 .time{
   width: 7.76vw;
   height: 5vw;
   border-radius: 0.5vw;
   display:flex;
   flex-direction: column;
   align-items: center;
   justify-content: center;
 }
 .event{
   width: 8.65vw;
   height: 6vw;
   overflow: visible;
   display: flex;
   flex-direction: column;
   align-items: center;
 }
 .event .arrow{
   margin-top: 1.25vw;
 }
  .event .sub{
   margin-top: 0.4vw;
   font-size: 0.9vw;
 }


 @media (min-width: 320px) and (max-width: 480px) {
   .time{
     width: 50vw;
     height: 22vw;
     padding-left: 0.8em;
     padding-right: 0.8em;
     border-radius: 2vw;
     box-sizing: border-box;
   }
   .time .year{
     font-size: 12px;
   }
   .time .date{
     font-size: 12px;
   }
   .event{
     width: 13.38vw;
     height: 9.28vw;
   }
   .event .arrow{
     margin-top: 1.25vw;
   }
   .time .main{
     margin-top: 0.625vw;
   white-space: nowrap;
     font-size: 12px;
   }
   .time .desc{
     margin-top: 0.4vw;
     font-size: 12px;
   }
 }

</style>
